const mutations = {
  setError(state, payload) {
    state.error = payload.error;
  },

  setOffline(state, payload) {
    state.offline = payload.offline;
  },

  setEmbed(state, payload) {
    state.embed = payload.embed;
  },

  setDebugMode(state, payload) {
    state.debugMode = payload.debugMode;
  },

  setTestMode(state, payload) {
    state.testMode = payload.testMode;
  },

  setPreviewMode(state, payload) {
    state.previewMode = payload.previewMode;
  },

  setNpsMode(state, payload) {
    state.npsMode = payload.npsMode;
  }
};

export default mutations;
